import React from 'react';
import PropTypes from 'prop-types';
import { Box, FDBox } from '@facet-wealth/design';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import WizardStepDeleteButton
  from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/WizardStepDeleteButton';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import RelationshipLinks from './RelationshipLinks';

const styles = (theme) => ({
  root: {},
  subtitle: {
    marginBottom: theme.spacing(4),
  },
  fields: {
    padding: theme.spacing(0),
  },
  deleteButton: {
    marginBottom: theme.spacing(2),
  },
});

const Layout = ({ classes }) => {
  const { loadModalCollectionByLink, setModalCollection, clearModalCollection } = useModalContext();
  const { loadPageContentLink } = usePageContentContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');
  async function handleDelete() {
    return resource.delete();
  }

  const onDeleteSuccess = async (resp) => {
    if (resp.isNoContent()) {
      clearModalCollection();
    } else {
      setModalCollection(resp);
    }
  };

  const handleSubmit = async () => {
    const resp = await onSubmit();

    // This means an error happened. so there is no point continuing
    if (!resp) {
      return resp;
    }

    const [respResource] = resp;

    if (respResource.relationship(fr.relationships.pageRefresh.name)) {
      loadPageContentLink(respResource.relationship(fr.relationships.pageRefresh.name).link('related'));
    }

    return resp;
  };

  return (
    <Box>
      <TitleSection />
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      {resource.meta().action('DELETE') ? <WizardStepDeleteButton
        className={classes.deleteButton}
        onDelete={handleDelete}
        onDeleteSuccess={onDeleteSuccess}
        dialogProps={{
          title: 'Are you sure?',
          message: 'Removing this item will delete all of its information. This cannot be undone.',
          cancelLabel: 'Nevermind',
          confirmLabel: 'Remove',
        }}
      /> : null}
      <FDBox paddingY={1}>
        <RelationshipLinks resource={resource} />
      </FDBox>
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={(resource.meta().canSubmit()) ? handleSubmit : null}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
